module.exports = __webpack_public_path__ + "static/media/thermometer.24293427.svg";